import React, { Component } from "react";
import "./IconInput.scss";

export default class IconInput extends Component {
    render() {
        return (
            <div className={"mb-1 w-100"}>
                <div
                    className={
                        "d-flex w-100" +
                        (this.props.isInvalid ? " border border-danger" : "")
                    }
                >
                    <div className="input-icon d-flex justify-content-center align-items-center">
                        <div><img src={this.props.icon} alt=""></img></div>
                    </div>
                    <input
                        disabled={this.props.disabled}
                        className="w-100 input-nlp custom-input"
                        type={this.props.type}
                        placeholder={this.props.placeholder}
                        onChange={this.props.onValueChange}
                        onKeyPress={this.props.onKeyPress}
                    />
                    {this.props.children}
                </div>
                <div className="small text-danger">{this.props.isInvalid}</div>
            </div>
        );
    }
}
